import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

function EstimatePopup({ isPopup, setIsPopup, onConfirm }) {
    const location = useLocation();
    const [popupActive, setPopupActive] = useState(false);

    useEffect(() => {
        const body = document.body;
        body.style.overflow = isPopup ? 'hidden' : 'auto';
        return () => {
            body.style.overflow = 'auto';
        };
    }, [isPopup]);

    useEffect(() => {
        let timeout;
        if (isPopup) {
            timeout = setTimeout(() => {
                setPopupActive(true);
            }, 100);
        } else {
            setPopupActive(false);
        }
        return () => clearTimeout(timeout);
    }, [isPopup]);

    useEffect(() => {
        document.body.style.overflow = 'auto';
    }, [location]);

    const handleClose = () => {
        setIsPopup(false);
    };
    
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        setIsPopup(false);
    };
    
    // 딤 배경 클릭 핸들러 추가
    const handleBackgroundClick = (e) => {
        // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
        if (e.target.className === 'popup-box-component') {
            setIsPopup(false);
        }
    };

    if (isPopup)
        return (
            <div 
                className="popup-box-component"
                onClick={handleBackgroundClick}
            >
                <div className={`box alert ${popupActive ? 'active' : ''}`}>
                    <div className="popup-content">
                        <p
                            className='p3_1' 
                            dangerouslySetInnerHTML={{ __html: isPopup }} 
                        />
                        <button 
                            type="button" 
                            className="confirm-btn"
                            onClick={handleClose}
                            style={{padding: '13.5px 40px'}}
                        >
                            취소
                        </button>
                        <button 
                            type="button" 
                            className="confirm-btn"
                            onClick={handleConfirm}
                            style={{padding: '13.5px 40px', backgroundColor: '#000', color: '#fff', marginLeft: '5px'}}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </div>
        );
    
    return null;
}

export default EstimatePopup;
